// Altruan: Bewertungs-Karussell. Pfeile/Punkte und Judge.me erst bei Bedarf nachladen.
if (!customElements.get("altruan-reviews")) {
  const MAIL_PARAMS = [
    "judgeme_token",
    "judgeme_review_uuid",
    "judgeme_dynamic_form",
    "judgeme_follow_up_token",
    "judgeme_upload_pictures",
    "judgeme_pre_verified",
  ];

  class AltruanReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector(".axrv__track");
      this.dots = this.querySelectorAll(".axrv__dots span");
      this.prev = this.querySelector('[data-act="prev"]');
      this.next = this.querySelector('[data-act="next"]');

      this.addEventListener("click", (e) => {
        const b = e.target.closest("button[data-act]");
        if (!b) return;
        const act = b.dataset.act;
        if (act === "prev" || act === "next") this.step(act === "next" ? 1 : -1);
        if (act === "write" || act === "all") this.openJudgeme(act, b);
      });

      if (this.track) {
        let ticking = false;
        this.track.addEventListener(
          "scroll",
          () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
              ticking = false;
              this.update();
            });
          },
          { passive: true },
        );
        this.update();
      }

      // Links aus den Judge.me-Mails (Bewertung schreiben, Fotos hochladen) brauchen das Original-Widget
      const { hash, search } = window.location;
      if (hash === "#judgeme" || hash === "#judgeme_product_reviews" || MAIL_PARAMS.some((p) => search.includes(p))) {
        this.openJudgeme("mail");
      }
    }

    get cardStep() {
      const card = this.track.firstElementChild;
      return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : 0;
    }

    step(dir) {
      const calm = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.track.scrollBy({ left: dir * this.cardStep, behavior: calm ? "auto" : "smooth" });
    }

    update() {
      const t = this.track;
      const w = this.cardStep;
      const i = w ? Math.round(t.scrollLeft / w) : 0;
      this.dots.forEach((d, k) => d.classList.toggle("is-on", k === i));
      if (this.prev) this.prev.disabled = t.scrollLeft < 4;
      if (this.next) this.next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
    }

    // Judge.me-Widget aus dem <template> einsetzen und den Loader erneut starten
    openJudgeme(act, button) {
      const full = this.querySelector(".axrv__full");
      const tpl = this.querySelector("template.axrv__jdgm");

      if (!this.loading && tpl) {
        full.append(tpl.content.cloneNode(true));
        tpl.remove();
        const loader = document.querySelector('script[src*="judgeme"][src*="loader.js"]');
        if (loader && window.jdgm) {
          delete window.jdgm._loaderExecuted;
          const s = document.createElement("script");
          s.src = loader.src;
          s.defer = true;
          document.body.appendChild(s);
        }
        this.loading = this.whenReady();
      }

      full.hidden = false;
      this.classList.add("is-full");
      if (button) button.setAttribute("aria-busy", "true");

      (this.loading || Promise.resolve()).then(() => {
        if (button) button.removeAttribute("aria-busy");
        this.hookScroll();
        if (act === "write") return this.openForm(full);
        if (act !== "mail") this.scrollTo(full);
      });
    }

    // Das Formular-Script von Judge.me kommt erst nach der Liste, daher bis zu 6 s erneut versuchen
    openForm(full, tries = 0) {
      const form = full.querySelector(".jdgm-form-wrapper");
      if (form && form.offsetHeight > 0) return this.scrollTo(form);
      if (tries > 30) return this.scrollTo(full);
      const link = full.querySelector(".jdgm-write-rev-link:not(.close-form-btn)");
      if (link && tries % 3 === 0) {
        // href="#" würde sonst an den Seitenanfang springen, solange Judge.me noch keinen Handler hat
        link.addEventListener("click", (e) => e.preventDefault(), { once: true });
        link.click();
      }
      setTimeout(() => this.openForm(full, tries + 1), 200);
    }

    // Judge.me scrollt sonst ohne Rücksicht auf die fixierte Kopfleiste; false überspringt sein eigenes Scrollen
    hookScroll() {
      const settings = window.jdgmSettings;
      if (!settings || this.hooked) return;
      this.hooked = true;
      const prev = settings.scrollTo;
      settings.scrollTo = (target, offset) => {
        const el = target && target[0];
        if (el && this.contains(el)) {
          this.scrollTo(el);
          return false;
        }
        return prev ? prev(target, offset) : undefined;
      };
    }

    scrollTo(el) {
      const calm = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      el.scrollIntoView({ behavior: calm ? "auto" : "smooth", block: "start" });
    }

    whenReady() {
      return new Promise((resolve) => {
        const started = Date.now();
        const check = () => {
          const w = this.querySelector(".jdgm-review-widget");
          if (!w || w.classList.contains("jdgm--done-setup-widget") || Date.now() - started > 15000) return resolve();
          setTimeout(check, 100);
        };
        check();
      });
    }
  }

  customElements.define("altruan-reviews", AltruanReviews);
}
